// Copyright (c) 2022 8th Wall, Inc.
//
// app.js is the main entry point for your 8th Wall app. Code here will execute after head.html is loaded, and before body.html is loaded.
import gameManagerComponent from './components/gameManagerComponent.js';
AFRAME.registerComponent('game-manager', gameManagerComponent);

import uiManagerComponent from './components/uiManagerComponent.js';
AFRAME.registerComponent('ui-manager', uiManagerComponent);

import audioManagerComponent from './components/audioManagerComponent.js';
AFRAME.registerComponent('audio-manager', audioManagerComponent);

import placeholderComponent from './components/placeholderComponent.js';
AFRAME.registerComponent('placeholder-component', placeholderComponent);

import cursorComponent from './components/cursorComponent.js';
AFRAME.registerComponent('cursor-component', cursorComponent);

import poiComponent from './components/poiComponent.js';
AFRAME.registerComponent('poi-component', poiComponent);

import drawOnTopComponent from './components/drawOnTop.js';
AFRAME.registerComponent('draw-on-top', drawOnTopComponent);

import lookAtComponent from './components/lookAtComponent.js';
AFRAME.registerComponent('look-at', lookAtComponent);

import poiDoorPanel from './components/points-of-interest/poi-door-panel.js';
AFRAME.registerComponent('poi-door-panel', poiDoorPanel);

import poiGuardian from './components/points-of-interest/poi-guardian.js';
AFRAME.registerComponent('poi-guardian', poiGuardian);

import poiFinalRobot from './components/points-of-interest/poi-final-robot.js';
AFRAME.registerComponent('poi-final-robot', poiFinalRobot);

import poiHolographicConsole from './components/points-of-interest/poi-holographic-console.js';
AFRAME.registerComponent('poi-holographic-console', poiHolographicConsole);

let mainMenu;
let aScene;
let reflectionComponent;
let currentSkyTextureId = 0;
let isChangingSky = false;
const skyTextures = [
  '#sky-texture1',
  '#sky-texture2',
  '#sky-texture3',
  '#sky-texture4',
  // '#sky-texture5',
  // '#sky-texture6',
  // '#sky-texture7',
  // '#sky-texture8',
  // '#sky-texture9',
  // '#sky-texture10',
  // '#sky-texture11',
];

window.onload = () => {
  aScene = document.querySelector('a-scene');
  aScene.addEventListener('loaded', () => {
    showMainMenu();
  });

  mainMenu = document.querySelector('#mainMenu');
  const startGameBtn = mainMenu.querySelector('#startGameBtn');
  startGameBtn.onclick = () => {
    window.audioManager.playSoundElement('#buttonSound');
    mainMenu.classList.add('hideAlpha');
    startGame();
  };

  const dpr = window.devicePixelRatio;
  // document.querySelector('#fuseCircleText').innerHTML = dpr;
  document.documentElement.style.setProperty('--dpr', dpr);
};

const showMainMenu = () => {
  mainMenu.classList.remove('hideAlpha');
}

const startGame = () => {
  // addXRWeb();
  const interactionCursor = aScene.querySelector('#interactionCursor');
  aScene.components['game-manager'].startGame();
  window.gameIsStarted = true;
  window.audioManager.playBackgroundSound();
  init();
}

const init = () => {
  document.querySelector('a-scene').components['game-manager'].customInit();
}

const addXRWeb = () => {
  aScene.setAttribute('xrweb', {
    scale: 'responsive',
    allowedDevices: 'any',
    disableDefaultEnvironment: true,
    defaultEnvironmentFogIntensity: 0,
    defaultEnvironmentSkyBottomColor: '#C9C6C9',
    defaultEnvironmentSkyTopColor: '#B7E8FF',
    defaultEnvironmentSkyGradientStrength: 0.3,
  });
}
